"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const views_1 = require("../core/views");
class ReferralModule extends views_1.ViewSet {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v2/referral/";
        this._canPaginate = false;
        this.update = async (id, contacted) => {
            return (await this._update(id, { contacted }));
        };
    }
    async listAgreements() {
        return (await this.get("/api/v2/referral/agreements/"));
    }
}
exports.default = ReferralModule;
//# sourceMappingURL=referral.js.map